import { TabsContainer } from './components/TabsContainer'

export function Tabs(props) {
  return <TabsContainer>{props.children}</TabsContainer>
}
